import { arcRoot } from '@/lib/queryRoots';

/** The draft ARC's query key, shared with the links sub-pages (P11). */
export { arcKey } from '@/lib/arcDraft';

/** One page of the Add Content picker's results, kept for a minute. */
export const arcContentKey = (
  organizationId: string | null,
  type: string | null,
  q: string,
  page: number,
) => [...arcRoot(organizationId), 'content', type, q, page] as const;

/** The light version check the open builder repeats (arc-and-discovery-hardening, D25). */
export const arcVersionKey = (organizationId: string | null) =>
  [...arcRoot(organizationId), 'version'] as const;
